import styles from "../Paragraph.module.css";

/**
 * HtmlText — wrapper dla treści HTML akapitu (text / text_1 / text_2).
 *
 * **Trust source:** content pochodzi z panelu admina Imperial — admin może
 * wstawić HTML (np. `<a>`, `<strong>`, listy, tabele) i jest to expected
 * feature, nie XSS. Backend (`IPARAGRAPH_CONTROLLER::parseVariables`) podmienia
 * jeszcze `{DOMAIN}` / `{YEAR}` placeholders przed wysłaniem.
 *
 * **Empty handling:** gdy text jest null/empty/whitespace — komponent nic nie
 * renderuje (zwraca `null`). Pozwala konsumentowi nie sprawdzać sam.
 */
export function HtmlText({
  html,
  className,
}: {
  html: string | null | undefined;
  className?: string;
}) {
  if (!html || typeof html !== "string" || html.trim() === "") return null;
  return (
    <div
      className={`${styles.htmlText} ${className ?? ""}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
